import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { renderKBUserInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton,
KBSelect } from
'components';
import * as selectors from 'app/selectors';
import { CONTRACTAPPROVALSETTING } from 'app/constants';
import { APPROVE_CONTRACT } from 'app/constants/hint';
import * as role from 'app/reducers/role';

var SpaceSettingLowPriceContractForm = class extends React.Component {constructor(props) {super(props);this.updateRoles = this.updateRoles.bind(this);}updateRoles(

  {
    abnormal_contract_role_setting,
    abnormal_contract_role_setting_users })
  {
    const { updateSpaceRole } = this.props;
    return updateSpaceRole({
      role: 'abnormal_contract',
      range: abnormal_contract_role_setting,
      user_ids:
      typeof abnormal_contract_role_setting_users === 'string' &&
      abnormal_contract_role_setting_users ?
      abnormal_contract_role_setting_users.split(',') :
      [] });

  }render()
  {
    const {
      fields: { abnormal_contract_role_setting_users },
      error,
      submitting,
      handleSubmit,
      users,
      selectUsers } =
    this.props;
    const hint = APPROVE_CONTRACT;
    return (
      <form onSubmit={handleSubmit(this.updateRoles)}>
        <KBFormError err={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <KBFormError err={error} />
          <div className="kb-row">
            <Field name="abnormal_contract_role_setting_users" component={renderKBUserInput}
            className={'kb-form-group kb-form-c18 kb-form-alone'}
            hint={hint.approver}
            title={'审批人'}
            users={users}
            selectedUsers={selectUsers}
            multi={true}
            />

          </div>

          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const { roles_settings = {}, roles = [] } = props.spaceRole || {};
  const setting_value = roles_settings.abnormal_contract_role_setting;
  let users = selectors.getSpaceUsers(state);
  let user_group = role.getRoleUserByKey(roles, 'abnormal_contract');
  let selectUsers = selectors.getUsersByUserIds(state, user_group) || [];

  return {
    users,
    selectUsers,
    initialValues: {
      abnormal_contract_role_setting: setting_value || 'group',
      abnormal_contract_role_setting_users: user_group || [] } };


}

const LEGACY_FORM_FIELDS = [
  "abnormal_contract_role_setting",
  "abnormal_contract_role_setting_users"
];

const formConfig = {
  form: 'SpaceSettingLowPriceContractForm',

  touchOnBlur: false };


export default connect(mapStateToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingLowPriceContractForm', LEGACY_FORM_FIELDS)(SpaceSettingLowPriceContractForm)));
